// Borrowed from https://stackoverflow.com/a/44577075
const wait = ms => new Promise(r => setTimeout(r, ms));
export default wait;
